module.exports = __webpack_public_path__ + "assets/img/EISS-Super-eBook.261cfa96.jpg";